import { render, staticRenderFns } from "./MenuTreeMb.vue?vue&type=template&id=038ed40e"
import script from "./MenuTreeMb.vue?vue&type=script&lang=js"
export * from "./MenuTreeMb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports